import React, { Component } from "react";
import AntdCard, {CardProps} from "antd/lib/card";
import "antd/lib/card/style";

const { Grid, Meta } = AntdCard;
export default class Card extends Component<CardProps> {
  static Grid = Grid;
  static Meta = Meta;
  render() {
    return <AntdCard {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/card/index.tsx